<template>
  <el-menu class="navbar" mode="horizontal">
    <hamburger class="hamburger-container" :toggleClick="toggleSideBar" :isActive="sidebar.opened"></hamburger>
    <breadcrumb></breadcrumb>
    <div class="company_name">{{userInfo.platform_name}}</div>
    <div class="navbarSearch">
      <div class="searchWrapper">
        <i class="n_searchIcon el-icon-search"></i>
        <el-input v-model="number" :placeholder="$t('home.numSearch')" @keyup.enter.native="handleSearchList"></el-input>
      </div>
    </div>
    <div class="noteWrapper" @click="noteDrawer = true">
      <img width="26" height="26"src="../../../assets/images/note.png" >
      <div class="noteText">{{$t('home.notebook')}}</div>
    </div>
    <el-divider direction="vertical"></el-divider>
    <el-dropdown class="avatar-container" trigger="click">
      <div class="avatar-wrapper">
        <img class="user-avatar" :src="avatar">
        <i class="el-icon-caret-bottom"></i>
      </div>
      <el-dropdown-menu class="user-dropdown" slot="dropdown">
        <router-link class="inlineBlock" to="/">
          <el-dropdown-item>
            {{$t('home.home')}}
          </el-dropdown-item>
        </router-link>
        <el-dropdown-item divided>
          <span @click="logout" style="display:block;">{{$t('home.signOut')}}</span>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <!-- <el-dropdown class="avatar-container" trigger="click" @command="changeLang">
      <div>
        <span>{{lang=='zh'?'中文':'English'}}</span>
        <i class="el-icon-arrow-down el-icon--right"></i>
      </div>
      <el-dropdown-menu class="user-dropdown" slot="dropdown">
      <el-dropdown-item command="zh">中文</el-dropdown-item>
      <el-dropdown-item command="en">English</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown> -->

    <el-drawer :visible.sync="noteDrawer" :append-to-body = "true" class="noteDrawerWrapper" size = "500px">
      <div slot="title" class="display">
        <img src="../../../assets/images/note_icon.png" >
        <span class="noteDrawerTitle">{{$t('home.notebook')}}</span>
      </div>
      <div class="noteConWrapper">
        <el-button type="primary" v-if="isNoteList" class="addNoteBtn" @click="addNote()">{{$t('home.addNotebook')}}</el-button>
        <ul class="noteList" v-if="isNoteList">
          <li class="noteListItem" v-for="item in noteList">
            <img width="30" height="30" src="../../../assets/images/portrait.png" >
            <div class="noteItemCon">
              <div style="font-weight: bold;margin-bottom: 8px;">{{item.nickname}}</div>
              <div>{{item.value}}</div>
              <div class="footerNote">
                <div>{{item.creation_time | formatDateTime}}</div>
                <div class="footerNoteNtns">
                  <el-button type="text" @click="delItem(item.notebook_id)" v-if="item.subuser_id==subuser_id">{{$t('home.del')}}</el-button>
                  <el-button type="text" style="color: rgb(54, 112, 255);" v-if="item.subuser_id==subuser_id" @click="editItem(item,'edit')">{{$t('home.edit')}}</el-button>
                  <el-button type="text" class="replyBtn">
                    <img width="16" height="16" src="../../../assets/images/reply.png" >
                    <span style="color: #1B1F26;vertical-align: text-top;" @click="tapReply(item.notebook_id)">{{$t('home.reply')}}</span>
                  </el-button>
                </div>
              </div>
              <template v-if="item.sub">
                <div class="noteItemCon replyWrapper" v-for="subItem in item.sub">
                  <div style="font-weight: bold;margin-bottom: 8px;">{{subItem.nickname}}</div>
                  <div>{{subItem.value}}</div>
                  <div class="footerNote">
                    <div style="margin-right: 10px;">{{subItem.creation_time | formatDateTime}}</div>
                    <div class="footerNoteNtns">
                      <el-button type="text" @click="delItem(subItem.notebook_id)" v-if="subItem.subuser_id==subuser_id">{{$t('home.del')}}</el-button>
                      <el-button type="text" style="color: rgb(54, 112, 255);" v-if="subItem.subuser_id==subuser_id" @click="editItem(subItem)">{{$t('home.edit')}}</el-button>
                      <el-button type="text" class="replyBtn">
                        <img width="16" height="16" src="../../../assets/images/reply.png" >
                        <span style="color: #1B1F26;vertical-align: text-top;" @click="tapReply(item.notebook_id)">{{$t('home.reply')}}</span>
                      </el-button>
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </li>
        </ul>
        <el-form ref="form" class="noteFormClass" :model="noteForm" v-else>
          <el-form-item :label="$t('home.permissions')+'：'" v-if="isreply">
            <el-radio-group v-model="noteForm.state">
              <el-radio label="1">{{$t('home.open')}}</el-radio>
              <el-radio label="0">{{$t('home.oneself')}}</el-radio>
              <el-radio label="2">{{$t('home.administrator')}}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item :label="$t('home.NotepadCon')+'：'">
            <el-input type="textarea" :placeholder="$t('home.recordInfo')" :rows="10" v-model="noteForm.value"></el-input>
          </el-form-item>
          <el-form-item style="text-align: center;">
            <el-button style="width: 221px;" type="primary" @click="edtiSubmit" v-if="editBtn">{{$t('home.submit')}}</el-button>
            <el-button style="width: 221px;" type="primary" @click="onSubmit" v-else>{{$t('home.submit')}}</el-button>
            <el-button style="width: 221px;" @click="isNoteList = true">{{$t('home.cancel')}}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-drawer>
  </el-menu>
</template>

<script>
import { mapGetters } from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'
import {setCookie,getCookie,removeCookie} from '@/utils/support';
import {formatDate} from '@/utils/date';
import { NotebookList,addNotebook,updateNotebook,deleteNotebook,editNotebook } from "@/api/login";

export default {
  components: {
    Breadcrumb,
    Hamburger
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'avatar',
      'userInfo'
    ])
  },
  data() {
    return {
      number: null,
      company_name:getCookie("company_name"),
      subuser_id:getCookie("subuser_id"),
      noteDrawer:false,
      noteList:[],
      isNoteList:true,
      isreply:false,
      noteForm:{
        state: '1',
        value: ''
      },
      notebook_id:null,
      parentEdit:false,
      editBtn:false,
      lang:this.$i18n.locale,
    }
  },
  created() {
    this.getNotebookList()
  },
  filters: {
    formatDateTime(time) {
      if (time == null || time === "") {
        return " ";
      }
      let date = new Date(time * 1000);
      return formatDate(date, "yyyy-MM-dd hh:mm:ss");
    }
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch('ToggleSideBar')
    },
    logout() {
      this.$store.dispatch('LogOut').then(() => {
        removeCookie('shopUser')
        location.reload() // 为了重新实例化vue-router对象 避免bug
      })
    },
    // 号码搜索
    handleSearchList(){
      // console.log('this.$route',this.$route.path)
      // console.log('number5656',this.number)
      // setCookie("number",this.number);
      // this.$router.replace({path: '/parts/parts'})
      this.$router.replace({path: '/parts/partsCP',query:{id:this.number}})

    },
    getNotebookList() {
      NotebookList().then((response) => {
        this.noteList = response.data.data;
      });
    },
    // 新增
    addNote(){
      this.isreply = true;
      this.isNoteList = false;
      this.noteForm.state = '1';
      this.noteForm.value = '';
      this.editBtn = false;
    },
    // 编辑
    editItem(item,type){
      if (type) {
        this.isreply = true;
        this.parentEdit = true;
      } else{
        this.isreply = false;
        this.parentEdit = false;
      }
      this.editBtn = true
      this.isNoteList = false;
      this.notebook_id = item.notebook_id;
      this.noteForm.state = item.state;
      this.noteForm.value = item.value;

    },
    // 编辑接口
    edtiSubmit(){
      this.isNoteList = true
      let data={}
      if (this.parentEdit) {
        data = {
          value:this.noteForm.value,
          state:this.noteForm.state,
          notebook_id:this.notebook_id,
        }
      } else{
        data = {
          notebook_id:this.notebook_id,
          value:this.noteForm.value,
        }
      }
      editNotebook(data).then((res) => {
        // console.log(res.data)
        if (res.data.status == 200) {
          this.$message({
            type: "success",
            message: res.data.msg,
            duration: 1000,
            offset: 200
          });
          this.getNotebookList()
        } else {
          this.$message({
            type: "error",
            message: res.data.msg,
            duration: 2000,
            offset: 200
          });
        }
      });

    },
    //回复
    tapReply(notebook_id){
      this.editBtn = false;
      this.isreply = false;
      this.isNoteList = false;
      this.notebook_id = notebook_id;
      this.noteForm.state = '1';
      this.noteForm.value = '';
    },
    // 删除
    delItem(notebook_id){
      this.notebook_id = notebook_id;
      let data = {
        notebook_ids:notebook_id
      }
      deleteNotebook(data).then((res) => {
        if (res.data.status == 200) {
          this.$message({
            type: "success",
            message: res.data.msg,
            duration: 1000,
            offset: 200
          });
          this.getNotebookList()
        } else {
          this.$message({
            type: "error",
            message: res.data.msg,
            duration: 2000,
            offset: 200
          });
        }
      });
    },
    onSubmit() {
      this.isNoteList = true
      if (this.isreply) {
        var data = {
          value:this.noteForm.value,
          state:this.noteForm.state,
        }
        // console.log('data',data)
        addNotebook(data).then((res) => {
          if (res.data.status == 200) {
            this.$message({
              type: "success",
              message: res.data.msg,
              duration: 1000,
              offset: 200
            });
            this.getNotebookList()
          } else {
            this.$message({
              type: "error",
              message: res.data.msg,
              duration: 2000,
              offset: 200
            });
          }
        });
      } else{
        var data = {
          notebook_id:this.notebook_id,
          value:this.noteForm.value,
        }
        updateNotebook(data).then((res) => {
          // console.log(res.data)
          if (res.data.status == 200) {
            this.$message({
              type: "success",
              message: res.data.msg,
              duration: 1000,
              offset: 200
            });
            this.getNotebookList()
          } else {
            this.$message({
              type: "error",
              message: res.data.msg,
              duration: 2000,
              offset: 200
            });
          }
        });

      }

    },
    // 切换语言
    changeLang(command){
    	this.lang=this.$i18n.locale = command
    	localStorage.setItem('lang',command)
      // console.log(this.$route.path)
      let path = this.$route.path
      if (path=='/shoppingCart/count'||path=='/shoppingCart/lackSuccessGoods'||path=='/shoppingCart/manageAddress'||path=='/shoppingCart/countSale') {
        this.$router.push({
          path: "/shoppingCart/cart",
        });
      } else{
        location.reload()
      }
      //
    },
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>

.navbar {
  height: 54px;
  line-height: 54px;
  border-radius: 0px !important;
  z-index: 1000;
  display: flex;
  align-items: center;
  .hamburger-container {
    line-height: 58px;
    height: 50px;
    float: left;
    padding: 0 10px;
  }
  .company_name{
    font-size: 18px;
    font-weight: bold;
    color: #3670FF;
    text-align: center;
    margin: auto;
  }
  .navbarSearch{
    display: inline-block;
    height: 50px;
    margin-right: 60px;
    margin-left: -20%;
    // position: absolute;
    // right: 135px;
    .searchWrapper{
      position: relative;
      margin-top: -3px;
      .n_searchIcon{
        width: 35px;
        line-height: 40px;
        text-align: center;
        position: absolute;
        left: 0;
        z-index: 9;
        top: 50%;
        transform: translateY(-50%);
        webkit-transform: translateY(-50%);
        -ms-transform: translateY(-50%);
      }
    }
    .el-input /deep/ .el-input__inner{ //第一种写法
        width: 250px !important;
        padding-left: 36px;
    }
  }
  .noteWrapper{
    line-height: 18px;
    margin-right: 35px;
    cursor: pointer;
    text-align: center;
    .noteText{
      font-size: 14px;
      color: #1B1F26;
    }
  }
  .el-divider--vertical{
    height: 2em;
  }
  .screenfull {
    position: absolute;
    right: 90px;
    top: 16px;
    color: red;
  }
  .avatar-container {
    height: 50px;
    display: inline-block;
    margin-right: 35px;
    margin-left: 35px;
    cursor: pointer;
    // position: absolute;
    // right: 35px;
    .avatar-wrapper {
      cursor: pointer;
      margin-top: 5px;
      height: 40px;
      position: relative;
      .user-avatar {
        width: 40px;
        height: 40px;
        border-radius: 50%;
      }
      .el-icon-caret-bottom {
        position: absolute;
        right: -22px;
        top: 15px;
        font-size: 12px;
      }
    }
  }
}
.noteDrawerWrapper{
  .noteDrawerTitle{
    font-size: 16px;
    font-weight: bold;
    color: #1B1F26;
    margin-left: 6px;
  }
  .noteConWrapper{
    padding: 0px 20px 20px;
    .addNoteBtn /deep/ .el-button{
      padding: 11px 15px;
    }
    .noteList{
      padding-top: 20px;
      .noteListItem{
        display: flex;
        margin-bottom: 20px;
        .noteItemCon{
          margin-left: 10px;
          font-size: 14px;
          width: 100%;
          .footerNote{
            display: flex;
            justify-content: space-between;
            align-items: center;
            color: #B3B5BA;
            font-size: 14px;
            .footerNoteNtns{
              display: flex;
              justify-content: space-between;
              align-items: center;
            }
            .footerNoteNtns /deep/ .el-button--text{
              color: #B3B5BA;
              font-size: 14px;
            }
          }
          .replyWrapper{
            border-left: 1px solid #DCDFE6;
            padding-left: 10px;
          }
        }
      }
    }
    .noteFormClass /deep/ .el-form-item__label{
      width: 100%;
      text-align: left;
      font-size: 14px;
      color: #1B1F26;
    }
    .noteFormClass /deep/ .el-form-item{
      margin-bottom: 15px;
    }
  }
}
.noteDrawerWrapper /deep/ .el-drawer{
  border-radius: 4px 4px 0px 0px;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/Navbar.vue